import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { withRouter } from "react-router-dom";
import "./verifyPhone.css";
import VerifyPhoneService from "./VerifyPhoneService.jsx";
import ReactCodeInput from "react-code-input";
import Result from "../../../components/result/Result.jsx";

import ErrorMessageComponent from "../../../components/errorMessageComponent/ErrorMessageComponent.jsx";
import { utils } from "../../../utils/Utils.jsx";

const VerifyPhone = (props) => {
  const [isMobileWidth, setIsMobileWidth] = useState(false);
  const [message, setMessage] = useState("");
  const [code, setCode] = useState("");
  const [invalidCode, setInvalidCode] = useState(false);
  const [stage, setStage] = useState(1);
  const [inputKey, setInputKey] = useState("");
  const [loadingPhone, setLoadingPhone] = useState(true);
  const [loadingSent, setLoadingSent] = useState(false);
  const [errorMessageType, setErrorMessageType] = useState("");
  const [goBackURL, setGoBackURL] = useState(null);

  const service = new VerifyPhoneService();

  useEffect(() => {
    checkProps();

    const setState = (updates) => {
      console.log("updates", updates);
      if (updates.message !== undefined) setMessage(updates.message);
      if (updates.loadingPhone !== undefined)
        setLoadingPhone(updates.loadingPhone);
    };

    service.confirmPhone(props.token, setState);

    checkWindowWidth();
    window.addEventListener("resize", checkWindowWidth);

    return () => {
      window.removeEventListener("resize", checkWindowWidth);
    };
  }, []);

  const checkWindowWidth = () => {
    const windowSize = window.innerWidth;
    const flag = windowSize <= 1000;

    checkGoBackNavBar(windowSize);
    setIsMobileWidth(flag);
  };

  const checkGoBackNavBar = (windowSize) => {
    if (windowSize <= 1000) {
      if (
        props.location &&
        props.location.megastate &&
        props.location.megastate.fromSettings
      ) {
        props.changeGoBackNavBar(true, "/dashboard/settings");
      } else {
        props.changeGoBackNavBar(true, "/dashboard");
      }
    }
  };

  const checkProps = () => {
    if (
      props.location &&
      props.location.megastate &&
      props.location.megastate.fromSettings
    ) {
      setGoBackURL("/dashboard/settings");
    } else {
      setGoBackURL("/dashboard/");
    }
  };

  const onChange = (value) => {
    setCode(value);
    if (value.length === 8 && !loadingSent) {
      validatePhone(value);
    }
  };

  const confirmPhone = () => {
    setLoadingPhone(true);
    setInputKey(inputKey + 1);
    setCode("");
    setInvalidCode(false);
    setErrorMessageType("");

    const setState = (updates) => {
      if (updates.message !== undefined) setMessage(updates.message);
      if (updates.loadingPhone !== undefined)
        setLoadingPhone(updates.loadingPhone);
    };

    service.confirmPhone(props.token, setState);
  };

  const validatePhone = (codeValue) => {
    const codeToValidate = codeValue || code;
    setErrorMessageType("");

    if (codeToValidate.length == 8) {
      setLoadingSent(true);

      const setState = (updates) => {
        if (updates.loadingSent !== undefined)
          setLoadingSent(updates.loadingSent);
        if (updates.stage !== undefined) setStage(updates.stage);
        if (updates.invalidCode !== undefined)
          setInvalidCode(updates.invalidCode);
      };

      service.validatePhone(
        props.token,
        codeToValidate,
        setState,
        setMessages,
        props.getClientConfig,
      );
    } else {
      setMessages("please-enter-an-8-digit-code");
      setInvalidCode(true);
    }
  };

  const setMessages = (type) => {
    setErrorMessageType(type);
  };

  return (
    <React.Fragment>
      <div class="verify-info-container page-container">
        <div class="middle-container container-padding">
          {stage === 1 ? (
            <div class="form-container">
              <div class="main-title">
                {props.localizedText["verify-phone"]}
              </div>
              {loadingPhone ? (
                <Spinner className="loader"></Spinner>
              ) : (
                <div class="div-parent-flex-column">
                  <p>
                    {props.localizedText[
                      "an-8-digit-verification-code-has-been-sent-to-your-phone"
                    ] + message}
                  </p>

                  <ReactCodeInput
                    fields={8}
                    name="code"
                    value={code}
                    onChange={onChange}
                    key={inputKey}
                    isValid={!invalidCode}
                    disabled={loadingSent}
                    type="tel"
                  ></ReactCodeInput>

                  <div class="resend-message">
                    {
                      props.localizedText[
                        "it-may-take-some-seconds-for-the-code-to-arrive!"
                      ]
                    }
                    <br />
                    {props.localizedText["still-a-minute?"]}
                    <b onClick={confirmPhone}>
                      &nbsp;{props.localizedText["resend-code"]}
                    </b>
                  </div>

                  <ErrorMessageComponent
                    errorMessage={props.localizedText[errorMessageType]}
                  ></ErrorMessageComponent>

                  <div class="buttons-div">
                    <Button
                      className="primary-button outside-primary-button"
                      onClick={validatePhone}
                      disabled={loadingSent}
                    >
                      {loadingSent ? (
                        <Spinner className="loader-send-outside-div-button"></Spinner>
                      ) : null}
                      {props.localizedText["verify"]}
                    </Button>

                    <Button
                      className="secondary-button outside-secondary-button"
                      onClick={() => utils.goToURL(props, goBackURL)}
                    >
                      {props.localizedText["cancel"]}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          ) : null}

          {stage === 2 ? (
            <Result
              success={true}
              secondButton={false}
              title={props.localizedText["success"]}
              message={
                props.localizedText[
                  "your-phone-has-been-successfully-validated"
                ]
              }
              primaryButtonText={props.localizedText["continue"]}
              primaryButtonFunction={() => utils.goToURL(props, goBackURL)}
            ></Result>
          ) : null}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(VerifyPhone);
